import React, {memo} from "react";

function Title(props) {
    const { record } = props;

    return (
        <div className="BaseTable__row-cell-text">
            {record.title || '-'}
        </div>
    );
}

export default memo(Title);
